import React from 'react';

export const CoffeeRequestProduct = () => {
  return <></>;
};
